import baseJs from './base'
import constList from '@/store/modules/ConstList'
import { getURLFromBase64, getArrangedDataSize } from '@/transformer/file'

export function getEmptyAchievementInfo() {
  return {
    achievement_id: 0,
    user_id: 0,
    title: '',
    detail: '',
    achievement_type_id: 1,
    issued_at: null,
    is_draft: 1,
    completion_program_time_id: '0',
    completion_program_course_id: '0',
    created_at: null,
    updated_at: null,
    link: null,
    files: [],
    achievementType: '',
    arrangedState: '',
    isEditable: 1
  }
}

export function getArrangedAchievement(achievement, typeList, programTimeList = []) {
  const arrangedData = {}

  // 編集権限のチェック
  arrangedData.isEditable = 0
  const type = typeList.find((type) => {
    return type.id === achievement.achievement_type_id
  })
  if (achievement.access_level === 2 && type && type.available === '1') {
    arrangedData.isEditable = 1
  }
  achievement.completion_program_course_id = Number(achievement.completion_program_course_id)
  achievement.completion_program_time_id = Number(achievement.completion_program_time_id)

  const achievementType = typeList.find((achievementType) => {
    return achievementType.id === achievement.achievement_type_id
  })
  if (achievementType) {
    achievement.display_achievent_type = achievementType.name
  } else {
    achievement.display_achievent_type = '不明'
  }

  if (achievement.completion_program_time_id) {
    const programTime = programTimeList.find((program) => {
      return Number(program.id) === achievement.completion_program_time_id
    })
    achievement.display_program_time = programTime !== undefined ? programTime.name : '指定なし'
  } else {
    achievement.display_program_time = '指定なし'
  }

  achievement.files = achievement.files.map((file) => {
    file.display_file_size = getArrangedDataSize(file.file_size)
    return file
  })
  return Object.assign(achievement, arrangedData)
}

export function getAchievementFieldsForAdmin(showAll, typeList) {
  const isEditableList = [
    { text: 'すべて', value: 'all' },
    { text: '編集可能', value: 1 },
    { text: '編集不可', value: 0 }
  ]
  typeList.unshift({ text: 'すべて', value: 'all' })
  return [
    { key: 'title', label: 'タイトル', sortable: showAll, textSearch: true },
    { key: 'detail', label: '', hidden: true, textSearch: true },
    { key: 'user_name', label: '修了生名', sortable: showAll, textSearch: true },
    { key: 'isEditable', label: '編集可否', hidden: true, selectSearch: isEditableList },
    { key: 'achievement_type_id', label: '成果種別', sortable: showAll, selectSearch: typeList },
    { key: 'issued_at', label: '日時', sortable: showAll, dateSearch: true },
    { key: 'management', label: '', tdClass: 'management' }
  ]
}
export function getAchievementFields(showAll, typeList) {
  const stateList = baseJs.getSelectionsByObject(constList.stateList)
  stateList.unshift({ text: 'すべて', value: 'all' })
  typeList.unshift({ text: 'すべて', value: 'all' })
  const returnList = [
    { key: 'title', label: 'タイトル', sortable: showAll, textSearch: true },
    { key: 'issued_at', label: '日時', sortable: showAll, dateSearch: true },
    { key: 'is_draft', label: '状態', selectSearch: stateList, hidden: true },
    { key: 'management', label: '', tdClass: 'management' }
  ]
  if (showAll) {
    returnList.splice(
      1,
      0,
      { key: 'detail', label: '', hidden: true, textSearch: true },
      { key: 'achievement_type_id', label: '成果種別', sortable: showAll, selectSearch: typeList }
    )
  }
  return returnList
}

export function createFileDownloadLink(res) {
  const url = getURLFromBase64(res.mime_type, res.base64)
  const downloadLink = document.createElement('a')
  downloadLink.download = res.file_name
  downloadLink.href = url
  downloadLink.dataset.downloadurl = [res.mime_type, res.file_name, downloadLink.href].join(':')
  return downloadLink
}

// function saveAchievementType (name, id = 0) {
// TODO:動作確認はまだ
// const params = new URLSearchParams()
// params.name = this.newTypeName
// if (id) {
//  params.id = this.id
// }
// await this.$axios.post(this.$constList.apiUrl + 'achievement/save_type', params)
//   alert('成果のタイプが追加/更新されます（未実装')
//   return { apiStatus: apiStatus, result: result }
// }
// }
